function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.67 0H14.19c.922 0 1.67.747 1.67 1.67v3.756a1.67 1.67 0 01-1.67 1.67H1.67A1.67 1.67 0 010 5.426V1.67C0 .747.747 0 1.67 0zm0 8.765H14.19c.922 0 1.67.748 1.67 1.67v3.756a1.67 1.67 0 01-1.67 1.67H1.67A1.67 1.67 0 010 14.19v-3.756c0-.922.747-1.67 1.67-1.67z",
  fill: "#636B75"
});

var SvgSteps = function SvgSteps(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1.66957 0H14.1913C15.1134 0 15.8609 0.74749 15.8609 1.66957V5.42609C15.8609 6.34816 15.1134 7.09565 14.1913 7.09565H1.66957C0.74749 7.09565 0 6.34816 0 5.42609V1.66957C0 0.74749 0.74749 0 1.66957 0ZM1.66957 8.76522H14.1913C15.1134 8.76522 15.8609 9.51271 15.8609 10.4348V14.1913C15.8609 15.1134 15.1134 15.8609 14.1913 15.8609H1.66957C0.74749 15.8609 0 15.1134 0 14.1913V10.4348C0 9.51271 0.74749 8.76522 1.66957 8.76522Z' fill='%23636B75'/%3E %3C/svg%3E";
export { SvgSteps as ReactComponent };